import VersionId from './VersionId';

export default VersionId;
